import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Dropdown, Icon, IconButton } from 'components';
import ActionsListMenu from './ActionsListMenu/ActionsListMenu';
import styles from './DotsActionsMenu.scss';

const DotsActionsMenu = ({ actions, className, comment }) => {
    return (
        <Dropdown
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            renderTrigger={({open, isOpen}) =>
                <IconButton
                    onClick={open}
                    className={
                        classnames(
                            styles.dotsMenu,
                            className,
                            { [styles.isOpen]: isOpen }
                        )
                    }
                    data-testid='dots-actions-menu__trigger'
                >
                    <Icon
                        name='ion-md-more'
                        horizontal
                    />
                </IconButton>
            }
            renderContent={({close}) =>
                <ActionsListMenu
                    actions={actions}
                    close={close}
                    comment={comment}
                />
            }
        />
    )
}

DotsActionsMenu.propTypes = {
    actions: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.string,
        label: PropTypes.string,
        icon: PropTypes.string,
        callback: PropTypes.func
    })),
    className: PropTypes.string,
    comment: PropTypes.shape({
        author: PropTypes.shape({
            email: PropTypes.string,
            name: PropTypes.string,
        }),
        createdAt: PropTypes.string,
        content: PropTypes.string,
        userAdmin: PropTypes.bool,
        allowedActions: PropTypes.arrayOf(PropTypes.string)
    }).isRequired
};

DotsActionsMenu.defaultProps = {
    actions: [],
    className: ''
};

export default DotsActionsMenu;

